import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { TextField, Button } from "@vitalsource/vstui";
import { cherry } from "@vitalsource/vstui/colors";
import { Translation, t } from "../../../core/translate";
import { GrayBlock } from "../styles";
import Link from "../../../components/link";
import Spinner from "../../../components/spinner";
import { selectors as userSelectors } from "../../../../redux/user";
import { emailPattern } from "../utils";

const SmallError = styled.div`
  color: ${cherry.getShade(2)};
  margin: -15px 0 15px 0;
`;

export class Email extends React.PureComponent {
  componentDidUpdate(prevProps) {
    if (!prevProps.emailStatus.approved && this.props.emailStatus.approved) {
      this.formError.focus();
    } else if (!prevProps.emailStatus.exists && this.props.emailStatus.exists) {
      this.email.focus();
    }
  }
  renderEmailExists() {
    return (
      <SmallError
        role="alert"
        tabIndex={-1}
        innerRef={x => (this.formError = x)}
        id="email-confirmation-field-form-control-message"
      >
        <div>
          <Translation id="registration.email-already-exists">
            An account with this email already exists.
          </Translation>{" "}
          <Link href="/user/signin" inline>
            <Translation id="signin.signin-button">Sign In</Translation>
          </Link>
        </div>
      </SmallError>
    );
  }
  renderEmailApproved() {
    return (
      <GrayBlock
        role="alert"
        tabIndex={-1}
        innerRef={x => (this.formError = x)}
      >
        <h2>
          <Translation id="registration.pre-approved">
            You’re Pre-Approved
          </Translation>
        </h2>
        <p>
          <Translation
            id="registration.pre-approved-text-no-html"
            resendLink={
              <Button
                href="https://support.vitalsource.com/hc/en-us/articles/213119637-Creating-an-Instructor-Account-for-Sampling"
                target="_blank"
                inline
              >
                <Translation id="lti.contact-support">
                  Contact Support
                </Translation>
              </Button>
            }
          >
            An email has been sent with instructions to complete your account
            activation.
          </Translation>
        </p>
      </GrayBlock>
    );
  }
  render() {
    const { emailStatus, checkingEmailStatus } = this.props;

    return (
      <div>
        {checkingEmailStatus && (
          <GrayBlock>
            <Spinner />
          </GrayBlock>
        )}
        {!checkingEmailStatus &&
          emailStatus.approved &&
          this.renderEmailApproved()}
        <TextField
          required
          fullWidth
          id="email-field"
          type="email"
          name="user[email]"
          label={t("base.email", "Email Address")}
          nativeFormControlRef={x => (this.email = x)}
          pattern={emailPattern}
        />
        {!checkingEmailStatus && emailStatus.exists && this.renderEmailExists()}
        <TextField
          required
          fullWidth
          id="email-confirmation-field"
          type="email"
          name="user[email-confirmation]"
          label={t("base.confirm-email", "Confirm Address")}
          nativeFormControlRef={x => (this.emailConfirmation = x)}
          validate={() => {
            if (this.email.value !== this.emailConfirmation.value) {
              return t("registration.email-no-match", "Emails must match.");
            }
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  checkingEmailStatus: userSelectors.isCheckingEmailExists(
    state,
    ownProps.submittedEmail
  ),
  emailStatus: userSelectors.getEmailStatus(state, ownProps.submittedEmail)
});

export default connect(mapStateToProps)(Email);
